export default "__VITE_ASSET__DMhqZOM6__"